import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { update, getOne, remove } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TextAreaWithPlaceholders from '../../../common/TextAreaWithPlaceholders';
import SelectContainer from '../../../common/SelectContainer';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const MessageTemplateEdit = () => {
    const navigate = useNavigate();
    const { template_id } = useParams();
    const [meta, setMeta] = useState({});
    const [data, setData] = useState(null);

    useEffect(() => {
        getOne('/admin/message-templates/', 'new').then((res) => setMeta(res.data.data)).catch(()=>{});
        getOne('/admin/message-templates/', template_id).then((res) => setData(res.data.data)).catch((e)=>{
            toast.error('Failed to load template');
            navigate('/settings/message_templates');
        });
    }, [template_id]);

    const handleSave = () => {
        update(`/admin/message-templates/${template_id}`, {data: data}).then(response => {
            toast.success("Template updated", {});
        }).catch(error => {
            toast.error("Error updating template: " + (error?.response?.data?.message || error.message), {});
        });
    }
    const handleCancel = () => {
        navigate('/settings/message_templates');
    }
    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    const placeholders = {
        user: { firstName: 'First Name', lastName: 'Last Name' },
        order: { id: 'Order ID', status: 'Order Status' },
        otp: { code: 'OTP Code' }
    };

    if (!data) return null;

    return (
        <div>
            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} closeOnClick pauseOnHover draggable progress="undefined" />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Edit Template: ${data.name}`} >
                <EditPagePanel className="col-lg-6">
                    <SelectContainer label="Channel" id="channel" onChange={ onChange } value={ data.channel } options={meta?.channels} />
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                </EditPagePanel>
                <EditPagePanel className="col-lg-6">
                    <SelectContainer label="Locale" id="locale" onChange={ onChange } value={ data.locale } options={meta?.locales} />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageCheckbox label="Active" id="is_active" onChange={ onChange } value={ data.is_active } />
                </EditPagePanel>

                {data.channel === 'email' && (
                    <EditPagePanel className="col-lg-12" title="Email Content">
                        <EditPageTextField label="Subject" id="subject" onChange={ onChange } value={ data.subject } />
                        <div style={{ marginBottom: '12px' }}>
                            <div style={{ fontWeight: 600, marginBottom: 6 }}>HTML Body</div>
                            <ReactQuill
                                theme="snow"
                                value={data.body_html || ''}
                                onChange={(content) => onChange('body_html', content)}
                                modules={{
                                    toolbar: [
                                        [{ header: [1, 2, 3, false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ list: 'ordered' }, { list: 'bullet' }],
                                        ['link', 'image'],
                                        [{ color: [] }, { background: [] }],
                                        ['clean']
                                    ]
                                }}
                                formats={['header','bold','italic','underline','strike','list','bullet','link','image','color','background']}
                                style={{ background: 'white' }}
                            />
                        </div>
                        <TextAreaWithPlaceholders id="body_text" value={data.body_text || ''} onChange={onChange} placeholders={placeholders} placeholderDisplayMap={{}} placeholder="Plain-text fallback (optional)" style={{minHeight:'120px'}}/>
                    </EditPagePanel>
                )}

                {data.channel !== 'email' && (
                    <EditPagePanel className="col-lg-12" title="Message Content">
                        <TextAreaWithPlaceholders id="body_text" value={data.body_text || ''} onChange={onChange} placeholders={placeholders} placeholderDisplayMap={{}} placeholder="Type message and insert variables with /..." style={{minHeight:'200px'}}/>
                    </EditPagePanel>
                )}
            </EditPage>
        </div>
    )
}

export default MessageTemplateEdit;


